import { WithT } from 'Modules/core/i18n';


export enum InvestorType {
    FL = 1,
    UL = 2,
    IP = 3,
}

export enum Role {
    INVESTOR = 1,
    ISSUER = 2,
}

export enum InvestorStatus {
    QUALIFIED = 1,
    NONE_QUALIFIED = 2,
}

export type FormValues = Partial<{
    role: Role;
    name: string;
    email: string;
    price: string;
    inn: string;
    rate: number;
    investorType: InvestorType;
    investorStatus: InvestorStatus;
}>

export interface FeedbackFormProps {
    formValues: FormValues;
}

export type SelectedTabComponentProps = Pick<FormValues, 'role'> & WithT;
